export const INJURY_REPORT_STATUS_IDS = {
  ALL: -2,
  OPEN: -1,
  NEW: 0,
  PENDING_MANAGER: 1,
  APPROVED_MANAGER: 2,
  REJECTED_MANAGER: 3,
  FOR_CONSIDERATION: 4,
  ASSET_DISCARDED: 5,
  ASSET_UNDER_REPAIR: 6,
  ASSET_REPAIRED: 7,
  CLOSED: 8,
}
